import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { FIELD_TYPES } from '../constants/fieldTypes';
export const generateFieldId = () => {
  return "field_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
};
export const validateSchema = schema => {
  const errors = [];
  if (!schema) {
    errors.push('Schema is required');
    return errors;
  }
  if (!schema.title || schema.title.trim() === '') {
    errors.push('Form title is required');
  }
  if (!schema.fields || !Array.isArray(schema.fields)) {
    errors.push('Form must have fields array');
    return errors;
  }
  if (schema.fields.length === 0) {
    errors.push('Form must have at least one field');
  }
  schema.fields.forEach((field, index) => {
    const fieldPrefix = "Field ".concat(index + 1);
    if (!field.id) {
      errors.push("".concat(fieldPrefix, ": Field ID is required"));
    }
    if (!field.label || field.label.trim() === '') {
      errors.push("".concat(fieldPrefix, ": Field label is required"));
    }
    if (!field.type || !FIELD_TYPES[field.type]) {
      errors.push("".concat(fieldPrefix, ": Valid field type is required"));
    }

    // Validate options for fields that require them
    if (['select', 'radio', 'checkbox'].includes(field.type)) {
      if (!field.options || !Array.isArray(field.options) || field.options.length === 0) {
        errors.push("".concat(fieldPrefix, ": Options are required for ").concat(field.type, " fields"));
      } else {
        field.options.forEach((option, optionIndex) => {
          if (!option.label || option.label.trim() === '') {
            errors.push("".concat(fieldPrefix, ", Option ").concat(optionIndex + 1, ": Option label is required"));
          }
          if (option.value === undefined || option.value === '') {
            errors.push("".concat(fieldPrefix, ", Option ").concat(optionIndex + 1, ": Option value is required"));
          }
        });
      }
    }
  });
  return errors;
};
export const exportSchema = function (schema) {
  let filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form-schema.json';
  const blob = new Blob([JSON.stringify(schema, null, 2)], {
    type: 'application/json'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
export const importSchema = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const schema = JSON.parse(e.target.result);
        const validationErrors = validateSchema(schema);
        if (validationErrors.length > 0) {
          reject(new Error("Invalid schema: ".concat(validationErrors.join(', '))));
        } else {
          resolve(schema);
        }
      } catch (error) {
        reject(new Error('Invalid JSON file'));
      }
    };
    reader.onerror = () => reject(new Error('Error reading file'));
    reader.readAsText(file);
  });
};
export const createEmptySchema = () => {
  return {
    title: '',
    description: '',
    fields: [],
    settings: {
      showProgressBar: false,
      showPageTitles: true,
      confirmationMessage: 'Thank you for your submission!'
    }
  };
};
export const duplicateField = field => {
  return _objectSpread(_objectSpread({}, field), {}, {
    id: generateFieldId(),
    label: "".concat(field.label, " (Copy)")
  });
};
export const moveFieldInArray = (fields, fromIndex, toIndex) => {
  const newFields = [...fields];
  const [movedField] = newFields.splice(fromIndex, 1);
  newFields.splice(toIndex, 0, movedField);
  return newFields;
};
export const getFieldValidationRules = field => {
  const rules = [];
  if (field.required) {
    rules.push('Required');
  }
  if (field.type === 'email') {
    rules.push('Valid email format');
  }
  if (field.type === 'number') {
    rules.push('Numeric value');
    if (field.min !== undefined) {
      rules.push("Min: ".concat(field.min));
    }
    if (field.max !== undefined) {
      rules.push("Max: ".concat(field.max));
    }
  }
  if (field.minLength !== undefined) {
    rules.push("Min length: ".concat(field.minLength));
  }
  if (field.maxLength !== undefined) {
    rules.push("Max length: ".concat(field.maxLength));
  }
  if (field.pattern) {
    rules.push('Custom pattern');
  }
  return rules;
};
export const formatFormData = (formData, schema) => {
  if (!schema || !schema.fields) return formData;
  const formatted = _objectSpread({}, formData);
  schema.fields.forEach(field => {
    const value = formatted[field.id];

    // Convert string numbers to actual numbers for number fields
    if (field.type === 'number' && typeof value === 'string' && value !== '') {
      const numValue = parseFloat(value);
      if (!Number.isNaN(numValue)) {
        formatted[field.id] = numValue;
      }
    }

    // Ensure checkbox fields are arrays
    if (field.type === 'checkbox' && !Array.isArray(value)) {
      formatted[field.id] = value ? [value] : [];
    }

    // Convert date strings to Date objects if needed
    if (field.type === 'date' && value && typeof value === 'string') {
      formatted[field.id] = new Date(value);
    }
  });
  return formatted;
};